<template>
    <div class="gtwm">
        <detailVue :articleId="article_id" v-if="show"></detailVue>
    </div>
</template>
<script>
import detailVue from '../../components/detail.vue';
export default {
  components: {
    detailVue
  },
  data() {
    return {
     article_id:'',
     column_id:'',
     show:false
     
    }
  },
  created() {
    this.column_id = this.$route.query.column_id
    this.getInfo()
  },
   beforeDestroy() {
        // 在组件销毁前，移除 popstate 事件监听
        window.removeEventListener('popstate', this.onPopState)
    },
    mounted() {
    // 添加 popstate 事件监听
    window.history.pushState(null, null, window.location.href);
    window.addEventListener('popstate', this.onPopState);
  },
  methods: {
    onPopState(e) {
      this.$router.replace({path:'/'})
    },
    getInfo(){
      let self =this
      this.$common.noLoginCallUrl('/api/cp-cms/site/info/getInfoPage',{
        column_id:self.column_id,
      },
      function(res){
        if(res.code == '000000'){
            let newList = res.data.data || []
            if(newList.length>0){
                self.article_id = newList[0].article_id
                self.show = true
            } 
        }else{
            self.$message.warning(res.msg)
        }
      })
    },
  },
  watch: { // 监听，当路由发生变化的时候执行
     $route(to, from) {
      this.showList =true
     }
  }
};
</script>

<style lang="less" >
.gtwm img{
    width: 100%;
}
</style>